var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProyectos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0C1.67969 0 0 1.25977 0 2.8125V27.1875C0 28.7402 1.67969 30 3.75 30H11.25V25.3125C11.25 23.7598 12.9297 22.5 15 22.5C17.0703 22.5 18.75 23.7598 18.75 25.3125V30H26.25C28.3203 30 30 28.7402 30 27.1875V2.8125C30 1.25977 28.3203 0 26.25 0H3.75ZM5 14.0625C5 13.5469 5.5625 13.125 6.25 13.125H8.75C9.4375 13.125 10 13.5469 10 14.0625V15.9375C10 16.4531 9.4375 16.875 8.75 16.875H6.25C5.5625 16.875 5 16.4531 5 15.9375V14.0625ZM13.75 13.125H16.25C16.9375 13.125 17.5 13.5469 17.5 14.0625V15.9375C17.5 16.4531 16.9375 16.875 16.25 16.875H13.75C13.0625 16.875 12.5 16.4531 12.5 15.9375V14.0625C12.5 13.5469 13.0625 13.125 13.75 13.125ZM20 14.0625C20 13.5469 20.5625 13.125 21.25 13.125H23.75C24.4375 13.125 25 13.5469 25 14.0625V15.9375C25 16.4531 24.4375 16.875 23.75 16.875H21.25C20.5625 16.875 20 16.4531 20 15.9375V14.0625ZM6.25 5.625H8.75C9.4375 5.625 10 6.04688 10 6.5625V8.4375C10 8.95312 9.4375 9.375 8.75 9.375H6.25C5.5625 9.375 5 8.95312 5 8.4375V6.5625C5 6.04688 5.5625 5.625 6.25 5.625ZM12.5 6.5625C12.5 6.04688 13.0625 5.625 13.75 5.625H16.25C16.9375 5.625 17.5 6.04688 17.5 6.5625V8.4375C17.5 8.95312 16.9375 9.375 16.25 9.375H13.75C13.0625 9.375 12.5 8.95312 12.5 8.4375V6.5625ZM21.25 5.625H23.75C24.4375 5.625 25 6.04688 25 6.5625V8.4375C25 8.95312 24.4375 9.375 23.75 9.375H21.25C20.5625 9.375 20 8.95312 20 8.4375V6.5625C20 6.04688 20.5625 5.625 21.25 5.625Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyectos);
export default __webpack_public_path__ + "static/media/Proyectos.0801c8d4173aeb891d8101806a63e400.svg";
export { ForwardRef as ReactComponent };